
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/furniture",
      function () {
        return require("private-next-pages/furniture.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/furniture"])
      });
    }
  